export default __webpack_public_path__ + "static/media/Wallet.14743479.svg";